<template>
    <nav>
       <v-toolbar flat app color="#2F478D" >
           <v-toolbar-side-icon  class="white--text" @click="drawer = !drawer"></v-toolbar-side-icon>
           <v-toolbar-title class="text-uppercase grey--text">
           </v-toolbar-title>
           <v-spacer></v-spacer>
           <!--<a href="/" style="text-decoration:none">-->
           <v-btn @click="closeSession()" flat color="white">
               <span>CERRAR SESIÓN</span>
           </v-btn>
          <!-- </a>-->
       </v-toolbar>

        <v-navigation-drawer  v-model="drawer" app style="background: linear-gradient(180deg, #3467AC, #2F488E);">    
            <v-list>            
                <v-layout  column align-center>
                    <!-- <v-flex class="mt-5">
                        <v-card class="pa-2" style="background-color:white;padding-left:10px;padding-right:10px" width="100%" > -->
                            <!-- <p align="center">
                            <img src="anuncio_canciones_lalabum.jpeg" width="100%">
                            </p> -->
                      
                        <!--<p align="center" >
                        <a href="https://us02web.zoom.us/j/84961106799?pwd=R1V5VnRLQjJLd0UrdnRweXJUTVhwQT09" 
                           class="textocapacitacion" 
                           target="_blank"
                           style="text-decoration: none; font-family:Fredoka one;color:white; padding: 3px; padding-left: 20px; padding-right: 20px; background-color: #2F478D; border-radius: 15px; " >
                           Entrar aquí
                            </a>
                        </p>-->
                        <!-- </v-card>
                    </v-flex> -->

                    <v-flex class="mt-5">
                        <v-avatar size="120" >
                            <img :src="img">
                        </v-avatar>
                    </v-flex>

                    <v-flex>
                        <br>
                        <span class="person" style="font-family:Poppins; color:white; font-weight:400;" >{{user}}</span>
                    </v-flex>
                    
                    <v-flex>
                        <br><br>
                        <span class="capacitacionmenu" style="font-family:Poppins; color:white; font-weight400; background:#244273; padding-left:5px; padding-right:5px;">{{progress+"%"}}</span>
                        <span class="textocapacitacion" style="font-family:Poppins; color:white;  font-weight:300;">  Capacitación</span>
                    </v-flex>
                </v-layout>
                <br><br>
            
       <!--<v-menu open-on-hover top upset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          color="white"
          dark
          v-on="on"
        >
          CAPACITACIONES
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
       </v-menu>-->


            
                <v-list-tile  v-for="link in links" :key="link.text" router :to="link.route" class="pl-3 pr-3">
                    <v-layout row wrap :class="`link ${link.text}`">
                        <v-list-tile-content>
                            <v-list-tile-title :class="`${link.text} white--text`">{{link.text}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-layout>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
   </nav>
</template>



<script>

import axios from 'axios'
export default {
    data(){
        return{
            drawer: true,
            persons:[
                {email:"info@lalabumapp.com",img:"avatar-5.png", capacitacion:"0%"}
            ],
            img:"avatar-5.png",
            user:'',
            progress:0,

            items: [
          {
            action: 'menu_book',
            title: 'CAPACITACIONES',
            items: [
              { title: 'VIDEOS CAPACITACION',route: '/videos_capacitacion'},
              { title: 'Manuales' ,route: '/manuales'},
            ],
          },
          {
            action: 'restaurant',
            title: 'PLANEACIONES',
            active: true,
            items: [
              { title: 'Breakfast & brunch' },
              { title: 'New American' },
              { title: 'Sushi' },
            ],
          },
          {
            action: 'school',
            title: 'DESCARGABLES',
            items: [
              { title: 'List Item' },
            ],
          },
          
        ],


            links:[
                {text:'CAPACITACIONES', route:'#'},
                {text:'VIDEOS CAPACITACIÓN', route: '/videos_capacitacion'},
                {text:'MANUALES', route: '/manuales'},
                {text:'PLANEACIONES', route: '/planeaciones1k'},
                {text:'DÍAS MUNDIALES ONU', route: '/planeaciones_onu'},
                {text:'1K', route: '/planeaciones1k'},
                {text:'2K', route: '/planeaciones2k'},
                {text:'3K', route: '/planeaciones3k'},
                {text:'DESCARGABLES', route: '/videos'},
                {text:'VIDEOS', route: '/videos'},
                {text:'CANCIONES', route: '/canciones'},
                {text:'CUENTOS', route: '/cuentos'},
                {text:'ACTIVIDADES', route: '/actividades'},
                {text:'DIBUJOS', route: '/dibujos'},
                {text:'LIBROS 2020-2021', route: '/libros'},
                {text:'EXPLICA CON LALABUM', route: '/lalabumexplica'},
                {text:'KITS DIDACTICOS', route: '/kits'},
                {text:'COREOGRAFÍAS', route:'/coreografias'},
                {text:'FONDOS VIRTUALES',route:'/fondosvirtuales'}
                
            ]   
        }

    },
    methods:{
        closeSession: function(){
            localStorage.removeItem('token')
            this.$router.push('/login')
        }
    },
    mounted(){
      let token  = localStorage.getItem('token')      
      const AuthStr = 'Bearer '.concat(token);
      axios.get("https://lalabumapp.com:4443/GetUserProgress",{ headers: { Authorization: AuthStr } })
      .then(resp => {
        this.user=resp.data.data.username
        this.progress=resp.data.data.completion
       
        
      })
      .catch(() => {
        
      })

    },
}
</script>

<style>
.link.CAPACITACIONES{
    background: linear-gradient(to left,#C1427A,#762A69);
    padding: 11px 10px 11px 10px;
    color:pink;
   
}

.link.PLANEACIONES{
    background: linear-gradient(to left,#2E65AC,#479FDA);
    padding: 11px 10px 11px 10px;
   
}

.link.DESCARGABLES{
    background: linear-gradient(to left,#CF4C46,#DC8B45);
    padding: 11px 10px 11px 10px;
}

@media (min-width: 1200px){
    .person{ 
        font-size:1.2vw!important;   
    }
    .capacitacionmenu{
         font-size:1.8vw;
    }
    .textocapacitacion{
        font-size:1.5vw;
    }
   
}

@media (min-width: 750px) and (max-width: 1200px){
    .person{ 
        font-size:2vw!important;   
    }
    .capacitacionmenu{
         font-size:3.2vw;
    }
    .textocapacitacion{
        font-size:2.5vw;
    }
}
@media (min-width: 300px) and (max-width: 750px){
    .person{
        font-size: 5.5vw;
    }
    .capacitacionmenu{
        font-size: 6.5vw;
    }
    .textocapacitacion{
        font-size:5.5vw;
    }
}


</style>

